import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getProgrammeSetting } from '@dealstack/frontend/shared/dataExchange/services/programme-setting.service.ts';

export const useProgrammeSetting = (mipId: string) => {
	return useQuery({
		queryKey: [API_PATHS.PROGRAMME_SETTING_MIP_GET, mipId],
		queryFn: () => getProgrammeSetting(),
		enabled: !!mipId,
		placeholderData: keepPreviousData,
		select: (data) => data.payload,
	});
};
